<template>
  <b-modal
    ref="goodReasons-modal-ref"
    hide-footer
    hide-header
  >
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5 class="vtd-modal-title">Good reasons to choose Trailfinders</h5>
        <button
          @click="closeModal"
          type="button"
          class="close"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div class="vtd-modal-body">
        <img 
          src="https://cdn.trailfinders.com/good-reasons.jpg" 
          alt="good-reasons-why-trailfinders-img"
          class="img-fluid"
        >
      </div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small
            >This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
export default {
  computed: {
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
  },
  methods: {
    showModal() {
      this.$refs["goodReasons-modal-ref"].show();
    },
    closeModal() {
      this.$refs["goodReasons-modal-ref"].hide();
    },
  }
};
</script>